import { render, staticRenderFns } from "./CkModalDay.vue?vue&type=template&id=ab2d292a&scoped=true"
import script from "./CkModalDay.vue?vue&type=script&lang=js"
export * from "./CkModalDay.vue?vue&type=script&lang=js"
import style0 from "./CkModalDay.vue?vue&type=style&index=0&id=ab2d292a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab2d292a",
  null
  
)

export default component.exports